export default "__VITE_ASSET__Ba9_Pls$__"